import axios from "../axios/index.js";

const urlGetHrmList = "/api/hrm/get-list";
const urlCreateHrm = "/api/hrm/create";
const urlUpdateHrm = "/api/hrm/update/";
const urlChangePassword = "/api/change-password"
const urlGetHrmDetail = "/api/hrm/detail/";
const urlDeleteHrm = "/api/hrm/delete/";

export default {
    getList(params) {
        return axios.get(urlGetHrmList, { 
            params: params
        });
    },

    getDetail(id) {
        return axios.get(urlGetHrmDetail + id);
    },

    create(params) {
        return axios.post(urlCreateHrm, params);
    },

    update(params) {
        return axios.post(urlUpdateHrm + params.id, params);
    },
    
    delete(id) {
        return axios.post(urlDeleteHrm + id, id);
    },

    changePassword(params) {
        return axios.post(urlChangePassword, params);
    },
};
